import { Certificate } from "pmt-types/src/models/Certificate.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationDownloadCertificate = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (certificate: Certificate) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/certificates/${certificate.id}/pdf`,
        {
          method: "GET",
          headers: {
            Accept: "application/pdf",
            "Content-Type": "application/pdf",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to download certificate");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      return {
        url: blobUrl,
      };
    },
    {
      onError: (error, data) => {
        console.error("Failed to download certificate", error, data);
      },
    },
  );
};
